import React from 'react';
import TitleMode from '../components/TitleMode';

const styles = {
    image: {
        display: 'none',
        width: '50px',
        margin: '5px 12px 0 0'
    },
    title: {
        display: 'inline-block',
        fontSize: 24,
        lineHeight: 1
    },
    mode: {
        display: 'inline-block',
        fontSize: 18,
        margin: '0 0 0 0.5em',
    }
};

let mode = localStorage.getItem('mode');

export const AppTitle = () => (
    <div>
        <img style={styles.image} src="CloudSent-POS-logo-admin-white.png" alt="CloudSent POS System Operator Portal"/>
        <span style={styles.title}>
            CloudSent POS System Operator Portal {/*- {localStorage.getItem('system')}*/}
            <TitleMode mode={mode} style={styles.mode}/>
        </span>
    </div>
);



// WEBPACK FOOTER //
// ./src/Fuse/global/title.js